import React from "react";
import _ from "lodash";

import IColumn from "models/IColumn";
import { PictureAsPdf } from "components/Icons";
import { downloadDocument } from "helpers/download";
import { markAsRead } from "../app/actions";
import { ROLE_IDS } from "constants/.";

export const columns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    key: "pdf",
    isSortable: false,
    fixedWidth: 52,
    render: rowData => (
      <PictureAsPdf
        id={`download-deliveries-${rowData.DocumentId}.pdf`}
        onClick={e => {
          e.stopPropagation();
          downloadDocument(
            rowData,
            () =>
              !_.get(rowData, "Read", true) &&
              markAsRead([rowData.Id], "Levering")
          );
        }}
      />
    ),
    visible: true,
    notRowClick: true
  },
  {
    title: "DELIVERIES_NR",
    key: "DeliveryId",
    fixedWidth: 164,
    visible: true
  },
  {
    title: "PURCHASE_TYPE",
    key: "RoleId",
    visible: true
  },
  {
    title: "DOCUMENT_DATE",
    key: "Date",
    type: "date",
    visible: true
  },
  {
    title: "DELIVERIES_END_DATE",
    key: "DeliveryDate",
    type: "date",
    visible: true
  },
  {
    title: "COUNTERPARTY_NAME",
    key: "OtherRelation.Name",
    visible: true
  },
  {
    title: "COUNTERPARTY_NR",
    key: "OtherRelation.Number",
    visible: true
  },
  {
    title: "PREFERRED_GROWER_NAME",
    key: "Supplier.Name",
    visible: true
  },
  {
    title: "GROWER_NR",
    key: "Seller.Number",
    render: rowData =>
      ROLE_IDS[rowData.RoleId] === "Seller"
        ? "-"
        : _.get(rowData, "Seller.Number", "-"),
    visible: false
  },
  {
    title: "GROWER_NAME",
    key: "Seller.Name",
    render: rowData =>
      ROLE_IDS[rowData.RoleId] === "Seller"
        ? "-"
        : _.get(rowData, "Seller.Name", "-"),
    visible: false
  },
  {
    title: "FYTOSANITAR",
    key: "Seller.FytosanitairNumber",
    visible: true
  },
  {
    title: "PREFERRED_GROWER_NR",
    key: "Supplier.Number",
    visible: false
  },
  {
    title: "BIO",
    key: "Bio",
    type: "boolean",
    visible: false
  }
];
